import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Container,
  Typography,
  Stack,
} from "@mui/material";
import { getToken, base_url } from "../../config/config";

const AddEmployee = () => {
  const [employee, setEmployee] = useState({
    name: "",
    email: "",
    position: "",
    shift: "",
  });

  const [shifts, setShifts] = useState([]); // To store available shifts

  // Fetch shifts on component mount
  useEffect(() => {
    const fetchShifts = async () => {
      try {
        const response = await axios.get(`${base_url}/v1/getshifts`);
        setShifts(response.data);
      } catch (error) {
        console.error("Error fetching shifts:", error);
      }
    };

    fetchShifts();
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployee({ ...employee, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${base_url}/v1/createEmployee`,
        employee,
      );
      console.log("Employee added:", response.data);
      setEmployee({ name: "", email: "", position: "", shift: "" }); // Reset form fields
    } catch (error) {
      console.error("Error adding employee:", error);
    }
  };

  return (
    <Container>
      <Typography variant='h4' align='center' gutterBottom>
        Add Employee
      </Typography>
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          {/* Name Field */}
          <TextField
            label='Name'
            name='name'
            value={employee.name}
            onChange={handleChange}
            required
            fullWidth
          />
          Email Field
          {/* <TextField
                        label="Email"
                        name="email"
                        type="email"
                        value={employee.email}
                        onChange={handleChange}
                        required
                        fullWidth
                    /> */}
          {/* Position Field */}
          {/* <TextField
                        label="Position"
                        name="position"
                        value={employee.position}
                        onChange={handleChange}
                        required
                        fullWidth
                    /> */}
          {/* Shift Selection */}
          <FormControl fullWidth required>
            <InputLabel id='shift-label'>Shift</InputLabel>
            <Select
              labelId='shift-label'
              name='shift'
              value={employee.shift}
              onChange={handleChange}
              label='Shift'>
              {shifts.map((shift) => (
                <MenuItem key={shift._id} value={shift._id}>
                  {shift.name} ({shift.startTime} - {shift.endTime})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* Submit Button */}
          <Button type='submit' variant='contained' color='primary' fullWidth>
            Add Employee
          </Button>
        </Stack>
      </form>
    </Container>
  );
};

export default AddEmployee;
